<!-- 陪练助手人员/部门选择(本地弹窗) -->
<template>
  <div class="practice-person-select" @click="openDialog">
    <div class="practice-person-select__text">
      <template v-if="rangeValue.length">
        <el-tag
          v-for="tag in rangeValue"
          :key="getItemKey(tag)"
          class="practice-person-select__tag"
          closable
          :disable-transitions="true"
          type="info"
          @click.stop
          @close="handleRemoveTag(tag)"
        >
          {{ getItemName(tag) }}
        </el-tag>
      </template>
      <div v-else class="practice-person-select__placeholder">请选择</div>
    </div>
    <i class="icon-arrow-down-s-line practice-person-select__arrow t-iconfont" />

    <PersonSelect v-model="rangeValueModel" v-model:show="visible" :max="200" />
  </div>
</template>

<script setup>
import { computed, ref } from 'vue'
import PersonSelect from '@/components/ai-person-select-v2/person-select.vue'

defineOptions({
  name: 'PracticePersonSelect'
})

const emits = defineEmits(['update:rangeValue', 'change'])
const props = defineProps({
  rangeValue: {
    type: Array,
    default: () => []
  }
})

const visible = ref(false)

const getItemName = (item = {}) => {
  return item.name || item.userName || item.employeeName || item.text || ''
}

const getItemId = (item = {}) => {
  return item.id || item.userId || item.employeeId || item.pid || ''
}

const getItemType = (item = {}) => {
  return item.property || (item.pid || item.text ? 'dept' : 'user')
}

const getItemKey = (item = {}) => {
  return `${getItemType(item)}-${getItemId(item)}`
}

const updateRangeValue = (value) => {
  emits('update:rangeValue', value)
  emits('change', value)
}

const rangeValueModel = computed({
  get() {
    return props.rangeValue
  },
  set(value) {
    updateRangeValue(value)
  }
})

const openDialog = () => {
  visible.value = true
}

const handleRemoveTag = (tag) => {
  updateRangeValue(props.rangeValue.filter((item) => getItemKey(item) !== getItemKey(tag)))
}
</script>

<style lang="scss" scoped>
.practice-person-select {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  width: 100%;
  overflow: hidden;
  border: 1px solid #e5e6eb;
  border-radius: 8px;
  background: #ffffff;
  cursor: pointer;

  &__text {
    box-sizing: border-box;
    display: flex;
    flex: auto;
    align-items: center;
    height: 32px;
    padding-right: 4px;
    padding-left: 4px;
    overflow-x: auto;
    line-height: 30px;
  }

  &__tag {
    margin-right: 6px;
  }

  &__placeholder {
    margin-left: 5px;
    font-size: 14px;
    color: #a9abb3;
  }

  &__arrow {
    display: flex;
    align-items: center;
    margin: 0 12px 0 8px;
  }
}
</style>
